import { createFileRoute } from "@tanstack/react-router"
import { DemandSettingsPage } from "~/components/settings/DemandSettingsPage"

export const Route = createFileRoute("/_auth/settings/_layout/demand")({
  component: DemandSettingsPage,
})
